// extracted by mini-css-extract-plugin
export default {"noResult":"EmptyProductSearch_noResult__dJ1je","requestInfo":"EmptyProductSearch_requestInfo__F2Uwc","requested":"EmptyProductSearch_requested__ZZLuK"};